import { Component, Input } from '@angular/core';

@Component({
    selector: 'ridango-ui-rotating-loading-spinner',
    templateUrl: './rotating-loading-spinner.component.html',
    styleUrls: ['./rotating-loading-spinner.component.scss'],
})
export class RotatingLoadingSpinnerComponent {
    @Input() ariaLabel: string;
}
